module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_06_6NW26_1SC_GLR.df67b6ad.png";